import React, { useEffect, useState } from 'react';
import { Col, Form, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Skeleton from 'react-loading-skeleton';
import { NavLink, useNavigate } from 'react-router-dom';
import { faChartLineUp, faScreenUsers, faUserEdit, faUserGear } from '@fortawesome/pro-solid-svg-icons';
import ClassCreateComponent from '../components/ClassCreate';
import NoAssignment from '../../../../../assets/images/ClassRoomModal.png';
import { faCaretDown, faCaretUp, faEdit, faEye, faChalkboardUser, faEyeSlash, faSearch, faCircleQuestion, faSave, faXmark } from '@fortawesome/free-solid-svg-icons';
import { useGetClassesForListMutation, useHideClassMutation, useUnhideClassMutation, useGetAllCoTeachersMutation, useRenameMutation } from '../../../../../features/authentication/classesApiSlice';
import ViewCoTeachersModal from '../../../../assignments/pages/AssignmentsAndActivities/Components/modals/ViewCoTeachersModal';
import CustomToast from '../../../../../components/Toast';
import { useClassContext } from '../../../components/classContext';
import Modal from '../../../../../components/Modal';
import DuplicateClass from '../components/DuplicateClass';
import Cookies from 'js-cookie';
import '../../../styles/classes.css';
import { useClassManagementContext } from '../../ClassManagement/utils/classManagementContext';
import ConfirmationModal from '../../../../../components/ConfirmationPopUp';

const Welcome = () => {

  const initialShowHiddenClasses = Cookies.get('showHiddenClasses') === 'true';

  const { setSelectedClassId } = useClassManagementContext();
  const [getClassesForList,{isLoading}] = useGetClassesForListMutation();
  const [hideClass, {isLoading: hideInProgress}] = useHideClassMutation();
  const [unhideClass,{isLoading: unhideInProgress}] = useUnhideClassMutation();
  const [getCoTeachers] = useGetAllCoTeachersMutation();
  const [rename] = useRenameMutation();
  const [classes, setClasses] = useState(null);
  const [sortColumn, setSortColumn] = useState('lName');
  const [sortDirection, setSortDirection] = useState('asc');
  const [showHiddenClasses, setShowHiddenClasses] = useState(initialShowHiddenClasses);
  const [searchText, setSearchText] = useState(null);
  const [debouncedSearchText, setDebouncedSearchText] = useState(searchText);
  const [openCoTeachersModal, setOpenCoTeachersModal] = useState(false);
  const [coteachers, setCoteachers] = useState([]);
  const { setClassId } = useClassContext();
  const [apiCallInProcess, setApiCallInProcess] = useState(false);
  const [dateBasedKey, setDateBasedKey] = React.useState(new Date().getTime().toString());
  const [openDuplicateModel, setOpenDuplicateModel] = useState(false);
  const [editIndex, setEditIndex] = React.useState(-1);
  const [updatedName, setUpdatedName] = React.useState('');
  const [nameBeforeUpdate, setNameBeforeUpdate] = React.useState('');
  const [isDistrictManaged, setIsDistrictManaged] = React.useState(false);
  const [nickname, setNickname] = React.useState('');
  const [editNickname, setEditNickname] = React.useState('');
  const [districtClassName, setDistrictClassName] = React.useState('');
  const [openDistrictClassEdit, setOpenDistrictClassEdit] = React.useState('');
  const [editClassId, setEditClassId] = React.useState(null);
  const [openDeleteConfirmation, setOpenDeleteConfirmation] = React.useState(false);
  const [openUnhideConfirmation, setOpenUnhideConfirmation] = React.useState(false);
  const [deleteHasStudent, setDeleteHasStudent] = React.useState(false);
  const [currentClassId, setCurrentClassId] = React.useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    Cookies.set('showHiddenClasses', showHiddenClasses, { expires: 7 });
  }, [showHiddenClasses]);

  const handleCreate = async (classModel) => {
    navigate(`${classModel.id}/classManagement/classManagement/addStudents`,{state: { selectedClass: {id:classModel.id, name:classModel.name}}});
  };

  const renderSortIcons = (column) => {
    if (sortColumn === column) {
      return sortDirection === 'asc' ?
        <span className='d-flex flex-column'>
          <FontAwesomeIcon icon={faCaretUp} size="sm" />
          <FontAwesomeIcon icon={faCaretDown} size="sm" className='align-caret-down opacity-25' />
        </span>
        :
        <span className='d-flex flex-column'>
          <FontAwesomeIcon icon={faCaretUp} size="sm" className='opacity-25' />
          <FontAwesomeIcon icon={faCaretDown} size="sm" className='align-caret-down' />
        </span>;
    }
    return (
      <span className='d-flex flex-column'>
        <FontAwesomeIcon icon={faCaretUp} size="sm" className='opacity-25' />
        <FontAwesomeIcon icon={faCaretDown} size="sm" className='align-caret-down opacity-25' />
      </span>
    );
  };

  const handleSort = (column) => {
    var direction = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';
    var sortedValue = [...classes].sort((a, b) => {
      return direction === 'asc' ? a[column].localeCompare(b[column]) : b[column].localeCompare(a[column]);
    });

    setSortColumn(column);
    setSortDirection(direction);
    setClasses(sortedValue);
  };

  const hideConfirmation = async (id,hasStudent)=>
  {
    setCurrentClassId(id);
    setDeleteHasStudent(hasStudent);
    setOpenDeleteConfirmation(true);
  };

  const manageHide = async () => {
    if (hideInProgress || !currentClassId || currentClassId<=0)
      return;

    try
    {
      await hideClass(currentClassId).unwrap();
    }catch(exception)
    {
      setOpenDeleteConfirmation(false);
      return;
    }
    CustomToast(deleteHasStudent?'Class Hidden Successfully':'Class Deleted Successfully', 'success');
    await triggerSearch(searchText, showHiddenClasses);
    setOpenDeleteConfirmation(false);
    setCurrentClassId(null);
    setDeleteHasStudent(null);
  };

  const manageUnhide = async () => {
    if (unhideInProgress || !currentClassId || currentClassId<=0)
      return;
    try{
      await unhideClass(currentClassId).unwrap();
    }catch(exception)
    {
      setOpenUnhideConfirmation(false);
      return;
    }
    CustomToast('Class Restored Successfully', 'success');
    triggerSearch(searchText, showHiddenClasses);
    setCurrentClassId(null);
    setOpenUnhideConfirmation(false);
  };

  const activeBadge = () => {
    return (<div className="activeBadge align-content-center">Active</div>);
  };

  const hiddenBadge = () => {
    return (<div className="disableBadge align-content-center" >Hidden</div>);
  };

  const handleInputChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleKeyPress = async (e) => {
    if (e.key === 'Enter') {
      await triggerSearch(searchText, showHiddenClasses);
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchText(searchText);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchText]);

  useEffect(() => {
    triggerSearch(debouncedSearchText, showHiddenClasses);
  }, [debouncedSearchText]);

  const triggerSearch = async (searchText, showHidden) => {
    const options = {
      searchKey: searchText ? searchText : '',
      displayHidden: showHidden != undefined ? showHidden : showHiddenClasses
    };

    var classes = await getClassesForList(options).unwrap();
    setClasses(classes);
    setSortDirection('asc');
  };

  const onDisplayHiddenChange = async () => {
    await setShowHiddenClasses(!showHiddenClasses),
    await triggerSearch(searchText, !showHiddenClasses);
  };

  const getCoteachersData = async (id, sourcedId) => {
    setClassId(id);
    setCoteachers(null);
    setOpenCoTeachersModal(true);
    setApiCallInProcess(true);
    var result = await getCoTeachers(id).unwrap();
    setCoteachers(result);
    setApiCallInProcess(false);
    setDateBasedKey(new Date().getTime().toString());
    setIsDistrictManaged(sourcedId?.length > 0);
  };

  const handleOnCloseCoTeachersModal = async () => {
    setOpenCoTeachersModal(false);
    await triggerSearch(debouncedSearchText, showHiddenClasses);
  };

  const handleDuplicateSave = async () => {
    setOpenDuplicateModel(false);
    await triggerSearch(debouncedSearchText, showHiddenClasses);
  };

  const handleUpdateClick = async (id) => {
    if (apiCallInProcess)
      return;
    if (!updatedName || updatedName.length == 0)
      return;
    if (nameBeforeUpdate == updatedName) {
      restUpdateValue();
      return;
    }

    setApiCallInProcess(true);
    var response = await rename({ id, name: updatedName });
    if (response.error) {
      if (response.error.data.errors)
        CustomToast(response.error.data.errors.Name, 'error');
      else
        CustomToast(response.error.data.error, 'error');
      restUpdateValue();
      return;
    }
    const updatedClasses = classes.map((item) => {
      return (item.id == id ? { ...item, name: updatedName } : { ...item });
    });
    localStorage.removeItem('classes');
    setClasses(updatedClasses);
    CustomToast('Class name saved successfully.', 'success');
    restUpdateValue();
  };

  const updateNickName = async () => {
    if (apiCallInProcess)
      return;
    if (!editClassId || editClassId <= 0 || !editNickname || editNickname.length == 0)
      return;
    if (nickname == editNickname) {
      restDistrictUpdateValue();
      return;
    }

    setApiCallInProcess(true);
    var response = await rename({ id: editClassId, name: editNickname });
    if (response.error) {
      if (response.error.data.errors)
        CustomToast(response.error.data.errors.Name, 'error');
      else
        CustomToast(response.error.data.error, 'error');

      restDistrictUpdateValue();
      return;
    }
    const updatedClasses = classes.map((item) => {
      return (item.id == editClassId ? { ...item, name: editNickname, nickName: editNickname } : { ...item });
    });
    localStorage.removeItem('classes');
    setClasses(updatedClasses);
    CustomToast('Nickname saved successfully.', 'success');
    restDistrictUpdateValue();
  };

  function restUpdateValue() {
    setApiCallInProcess(false);
    setEditIndex(-1);
    setUpdatedName('');
    setNameBeforeUpdate('');
  }

  function restDistrictUpdateValue() {
    setApiCallInProcess(false);
    setEditIndex(-1);
    setOpenDistrictClassEdit(false);
    setDistrictClassName('');
    setEditNickname('');
    setNickname('');
    setEditClassId(null);
  }

  const handleEditClick = (index, classItem) => {
    restDistrictUpdateValue();
    restUpdateValue();
    if (classItem.sourcedId?.length > 0) {
      setOpenDistrictClassEdit(true);
      setDistrictClassName(classItem.districtClassName);
      setEditNickname(classItem.nickName);
      setNickname(classItem.nickName);
      setEditClassId(classItem.id);
    }
    else {
      setEditIndex(index);
      setUpdatedName(classItem.name);
      setNameBeforeUpdate(classItem.name);
    }
  };

  const handleInputNameChange = (event) => {
    const { value } = event.target;
    setUpdatedName(value);
  };


  return (
    <div className='bg-white px-5 border-radius-15'>
      <Row>
        <Col>
          <section className='mt-5'>
            <h5>My Classes</h5>
          </section>
          {(searchText == null && !isLoading && classes?.length == 0) &&
            <Row>
              <Col>
                <div className="no-assignments-card mb-3 px-5">
                  <div className="text-center">
                    <img src={NoAssignment} className="my-4" />
                    <p className="">
                      You do not have any classes at this time, Use the <b>Create New</b> button to add a class.
                    </p>
                  </div>
                  <div className='offset-3 pb-5'>
                    <ClassCreateComponent
                      handleCreate={(model)=> handleCreate(model)}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          }
        </Col>
      </Row>
      <Row>
        <div className='p-2 col-md-7'>
          <ClassCreateComponent
            handleCreate={handleCreate}
          />
        </div>
        <hr />
      </Row>
      <Row>
        <div>
          <div className="d-flex py-4">
            <div className='me-auto col-md-3'>
              <div className="custom-search position-relative">
                <FontAwesomeIcon icon={faSearch} />
                <input
                  type="text"
                  placeholder="Search Class"
                  className="form-control"
                  id="search"
                  value={searchText}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyPress}
                />
              </div>

            </div>
            <div className='d-flex align-items-center gap-3'>
              <div className='p-1'>
                <Form.Check
                  type="checkbox"
                  id="showHiddenClasses"
                  className="d-flex flex-row align-items-center">
                  <Form.Check.Input
                    type="checkbox"
                    className='mx-1'
                    checked={showHiddenClasses}
                    onChange={onDisplayHiddenChange}
                  />
                  <Form.Check.Label>
                    {'Display Hidden Classes '}
                    <OverlayTrigger
                      key="visibilityStatus" badge-pink-light
                      placement="top"
                      overlay={<Tooltip className="custom-tooltip" >
                        <div className='w-100'>
                              Classes with co-teachers cannot be hidden
                        </div>
                      </Tooltip>}>
                      <FontAwesomeIcon icon={faCircleQuestion} color="#88CBF1" />
                    </OverlayTrigger>
                  </Form.Check.Label>
                </Form.Check>
              </div>
              <div className='p-1'>
                <button
                  onClick={() => setOpenDuplicateModel(true)}
                  className="btn-link secondary-link px-0 text-start">
                  <i className="fa-sharp fa-solid fa-copy me-2"></i>Duplicate Existing Class
                </button>
              </div>
            </div>
          </div>
          <table className='table reportTable'>
            {!isLoading ? (
              <>
                <thead className='thead-light align-middle thead-fixed'>
                  <tr>
                    <th scope="col" className='fw-medium cursor-pointer w-50' onClick={() => handleSort('name')}>
                      <span className='d-flex justify-content-between'><span>Class Name</span> {renderSortIcons('name')}</span>
                    </th>
                    <th scope="col" className='fw-medium text-center' onClick={() => handleSort('topicName')}>
                      {'Visibility Status '}
                      <OverlayTrigger
                        key="visibilityStatus"
                        placement="top"
                        overlay={<Tooltip className="custom-tooltip" >
                          <div className='w-100'>
                            <b>Active:</b> Current classes coming over from nightly automation AND any manually created classes
                            <br /> <b>Hidden:</b> Classes that the teacher has chosen to hide(can be ones that come over from nightly automation OR any manually created classes)
                            <br /><b>Disabled:</b> A district change in the nightly automation data.
                          </div>
                        </Tooltip>}>
                        <FontAwesomeIcon icon={faCircleQuestion} color="#88CBF1" />
                      </OverlayTrigger>
                    </th>
                    <th scope="col" className='fw-medium text-center' onClick={() => handleSort('sourcedId')}>
                          Class Source Id
                    </th>
                    <th scope="col" className='fw-medium'>
                      <span className='align-items-center d-flex justify-content-between'>     </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {classes?.map((item, index) => (
                    <tr key={`record_${item.id}`}>
                      <td className={`${item.deleted ? '' : 'd-flex'}`}>
                        <div className={`align-content-around me-auto ${editIndex === index ? 'col-10' : ''}`}>
                          {editIndex === index ? (
                            <input
                              className="form-control"
                              type="text"
                              value={updatedName}
                              onChange={(event) => handleInputNameChange(event, index)}
                              disabled={apiCallInProcess}
                            />
                          ) : (
                            <>
                              <div className='d-flex'>
                                {item.name}
                                <div>
                                  {item.classHaveCoTeacher && !item.coTeacherClass &&
                                      <OverlayTrigger
                                        placement="right"
                                        overlay={
                                          <Tooltip id="tooltip-top" className="initial-assignment-tooltip">
                                            <div>You are the owner of this class</div>
                                            <div className='text-start mx-3'>
                                              <div className='fw-semibold mt-2'>Co-Teachers</div>
                                              {(item.coTeachers ?? []).slice(0, 10).map((coteacher, index) => (
                                                <div key={index}>{coteacher.name} {coteacher.allowEdit && <FontAwesomeIcon className='fs-7' icon={faUserEdit}/> }</div>
                                              ))}

                                              {(item.coTeachers?.length ?? 0) > 10 && (
                                                <div>+{item.coTeachers.length - 10} more</div>
                                              )}

                                              {(item.coTeachers ?? []).some(ct => ct.allowEdit) && (
                                                <div className="mt-2">
                                                  <FontAwesomeIcon className='fs-7' icon={faUserEdit}/> means co-teacher is allowed to edit the class
                                                </div>
                                              )}
                                            </div>
                                          </Tooltip>
                                        }>
                                        <span className='badge badge-info mx-2'>
                                          <FontAwesomeIcon icon={faChalkboardUser}/>
                                        </span>
                                      </OverlayTrigger>
                                  }
                                </div>
                                <div>
                                  {item.coTeacherClass && 
                                  <OverlayTrigger
                                    placement="right"
                                    overlay={
                                      <Tooltip id="tooltip-top" className="initial-assignment-tooltip">
                                        You are the Co-Teacher on this class
                                        <div className='mt-2'><strong>Owner :</strong> {item.teacherName}</div>
                                      </Tooltip>
                                    }>
                                    <div className="badge badge-info-light fw-normal mx-1">
                                      <FontAwesomeIcon icon={faUserGear}/>
                                    </div>
                                  </OverlayTrigger>
                                  
                                  }
                                </div>
                              </div>

                              {item.sourcedId?.length > 0 &&
                                    <span className="badge badge-pink-light fw-normal">
                                      <i className="fa-sharp fa-solid fa-id-card-clip me-2"></i>District Managed
                                    </span>
                              }
                                  
                            </>
                          )}
                        </div>
                        {!item.deleted && (!item.coTeacherClass || item.coTeacherAllowEdit) && <div className='align-content-center'>
                          {editIndex === index ? (
                            <div>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id="tooltip-top" className="custom-tooltip">
                                        Cancel
                                  </Tooltip>
                                }>
                                <button className='btn grid-icon-btn renameCancel' disabled={apiCallInProcess} onClick={() => setEditIndex(-1)}>
                                  {' '}
                                  <FontAwesomeIcon icon={faXmark} className='fa-2x renameCancel' />
                                </button>
                              </OverlayTrigger>

                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id="tooltip-top" className="custom-tooltip">
                                        Update
                                  </Tooltip>
                                }>
                                <button className='btn grid-icon-btn renameSave mr-1 p-1'
                                  onClick={() => handleUpdateClick(item.id)}
                                  disabled={apiCallInProcess || !updatedName || updatedName.length == 0}
                                >
                                  {' '}
                                  <FontAwesomeIcon icon={faSave} className='fa-2x clr-castleRed' />
                                </button>
                              </OverlayTrigger>
                            </div>
                          ) : (
                            <>
                              <OverlayTrigger
                                key="rename"
                                placement="top"
                                overlay={<Tooltip className="custom-tooltip">Rename</Tooltip>}>
                                <button
                                  id={'rename' + item.id}
                                  className="btn grid-icon-btn info-icon-btn"
                                  onClick={() => handleEditClick(index, item)}
                                >
                                  <FontAwesomeIcon icon={faEdit} />
                                </button>
                              </OverlayTrigger>
                            </>
                          )}
                        </div>}
                      </td>
                      <td className='text-center'>{item.deleted ? hiddenBadge() : activeBadge()}</td>
                      <td className='text-center'>{item.sourcedId ? item.sourcedId : 'N/A'}</td>
                      <td>
                        <div className='align-items-center justify-content-start px-2 d-flex'>

                          {!item.deleted &&
                                <NavLink to={`${item.id}/classManagement`} onClick={setSelectedClassId(null)}>
                                  <OverlayTrigger
                                    key="manageClass"
                                    placement="top"
                                    overlay={<Tooltip className="custom-tooltip"> Class Management </Tooltip>}>
                                    <button
                                      id={'classManagement' + item.id}
                                      className="btn grid-icon-btn info-icon-btn mr-2"
                                      disabled={apiCallInProcess}
                                    >
                                      <FontAwesomeIcon icon={faScreenUsers} />
                                    </button>
                                  </OverlayTrigger>
                                </NavLink>
                          }

                          {!item.deleted &&
                                <NavLink to={`${item.id}/classSessionsAndReport`}>
                                  <OverlayTrigger
                                    key="classSessionsAndReport"
                                    placement="top"
                                    overlay={<Tooltip className="custom-tooltip"> Sessions & Report </Tooltip>}>
                                    <button
                                      id={'classSessionsAndReport' + item.id}
                                      className="btn grid-icon-btn info-icon-btn mr-2"
                                      disabled={false}
                                    >
                                      <FontAwesomeIcon icon={faChartLineUp} />
                                    </button>
                                  </OverlayTrigger>
                                </NavLink>
                          }

                          {!item.deleted && !item.coTeacherClass && ((!item.sourcedId || item.sourcedId.length == 0) || item.classHaveCoTeacher) && <OverlayTrigger
                            key="AddCoteacher"
                            placement="top"
                            overlay={<Tooltip className="custom-tooltip">View/Add Co-teacher</Tooltip>}>
                            <button
                              id={'addCoteacher' + item.id}
                              className='btn grid-icon-btn info-icon-btn mr-2'
                              disabled={apiCallInProcess}
                              onClick={async () => { getCoteachersData(item.id, item.sourcedId); }}
                            >
                              <FontAwesomeIcon icon={faChalkboardUser} />
                            </button>
                          </OverlayTrigger>
                          }

                          {!item.coTeacherClass && <OverlayTrigger
                            key="hideClass"
                            placement="top"
                            overlay={<Tooltip className="custom-tooltip">{item.sourcedId?.length > 0 ? 'District managed class cannot be hidden' : (!item.classHaveCoTeacher ? (item.deleted ? 'Unhide' : 'Hide') : 'Class with co-teachers cannot be hidden')}</Tooltip>}>
                            <div>
                              <button
                                id={'hideClass' + item.id}
                                className='btn grid-icon-btn info-icon-btn mr-2'
                                disabled={(apiCallInProcess || item.classHaveCoTeacher || item.sourcedId?.length > 0)}
                                onClick={async () => { !item.classHaveCoTeacher ? (item.deleted ? (setOpenUnhideConfirmation(true), setCurrentClassId(item.id)): hideConfirmation(item.id, item.hasStudent)) : ''; }}
                              >
                                <FontAwesomeIcon icon={item.deleted ? faEye : faEyeSlash} className={(item.classHaveCoTeacher || item.sourcedId?.length > 0) && 'info-icon-btn-disabled'} />
                              </button>
                            </div>
                          </OverlayTrigger>
                          }

                        </div>
                      </td>
                    </tr>
                  ))}
                  {classes?.length == 0 && <div className='p-3 text-danger'>No Record Found</div>}
                </tbody>
                <tfoot></tfoot>
              </>
            ) : (
              <>
                <tbody>
                  <tr className="score-table-head">
                    <th> <Skeleton /></th>
                    <th> <Skeleton /></th>
                    <th> <Skeleton /></th>
                    <th> <Skeleton /></th>
                    <th> <Skeleton /></th>
                  </tr>
                  <tr className="table-body">
                    <td><Skeleton /></td>
                    <td><Skeleton /></td>
                    <td><Skeleton /></td>
                    <td><Skeleton /></td>
                    <td><Skeleton /></td>
                  </tr>
                  <tr className="table-body">
                    <td><Skeleton /></td>
                    <td><Skeleton /></td>
                    <td><Skeleton /></td>
                    <td><Skeleton /></td>
                    <td><Skeleton /></td>
                  </tr>
                  <tr className="table-body">
                    <td><Skeleton /></td>
                    <td><Skeleton /></td>
                    <td><Skeleton /></td>
                    <td><Skeleton /></td>
                    <td><Skeleton /></td>
                  </tr>
                </tbody>
              </>
            )}
          </table>
        </div>
      </Row>

      {openCoTeachersModal && (
        <ViewCoTeachersModal
          key={dateBasedKey}
          modalData={openCoTeachersModal}
          onClose={() => handleOnCloseCoTeachersModal()}
          coteachers={coteachers}
          setCoteachers={setCoteachers}
          coTeachersDataLoading={apiCallInProcess}
          isDistrictManaged={isDistrictManaged}
        />
      )}

      {openDuplicateModel && (
        <Modal
          isOpen={openDuplicateModel}
          onClose={() => setOpenDuplicateModel(false)}
          contentWidth="65%"
          titleName={'Duplicate Existing Class'}
        >
          <DuplicateClass onCancel={() => setOpenDuplicateModel(false)} handleSave={() => handleDuplicateSave()} />
        </Modal>
      )}

      {openDistrictClassEdit && (
        <Modal
          isOpen={openDistrictClassEdit}
          onClose={() => setOpenDistrictClassEdit(false)}
          contentWidth="40%"
          titleName={'Add/Update Nickname'}
        >
          <Row className='mb-3'>
            <Col className='col col-4 d-flex gap-2 p-0'>
              <div className='fw-medium'>District Class Name</div>
            </Col>
            <Col>
              <div className='fw-normal'>{districtClassName}</div>
            </Col>
          </Row>
          <Row>
            <Col className='align-items-center col-4 d-flex gap-4 p-0'>
              <div className='fw-medium'>Class Nickname</div>
            </Col>
            <Col>
              <div className='fw-normal d-flex align-content-center'>   <input
                className="form-control"
                type="text"
                value={editNickname}
                onChange={(event) => setEditNickname(event.target?.value)}
              />
                &nbsp;
              <div className='align-content-center'>
                <OverlayTrigger
                  key="visibilityStatus"
                  placement="top"
                  overlay={<Tooltip className="custom-tooltip" >
                    <div className='w-100'>
                        The Class Nickname you choose here will display everywhere on the site, instead of the District Class Name. The nickname will also be visible to co-teachers and admins.
                    </div>
                  </Tooltip>}>
                  <FontAwesomeIcon icon={faCircleQuestion} color="#88CBF1" />
                </OverlayTrigger>
              </div>
              </div>
            </Col>
          </Row>
          <Row className='justify-content-end mt-4'>
            <Col className='col-5'>
              <div className='d-flex justify-content-end'>
                <button className='btn btn-castleGray flex-grow-1 mr-2'
                  onClick={() => setOpenDistrictClassEdit(false)}
                  disabled={apiCallInProcess}>
                  Cancel
                </button>
                <button
                  className='btn btn-castleRed flex-grow-1'
                  onClick={() => updateNickName()}
                  disabled={apiCallInProcess}
                >
                  Save&nbsp;
                </button>
              </div>
            </Col>
          </Row>
        </Modal>

      )}

      <ConfirmationModal
        isOpen={openDeleteConfirmation}
        onClose={() => setOpenDeleteConfirmation(false)}
        onSave={() => manageHide()}
        contentWidth={'40%'}
        buttonPosition={'center'}
        titleName={`${deleteHasStudent? 'Hide Confirmation' : 'Delete Confirmation'}`}
        content={`${deleteHasStudent? 'Are you sure that you want to hide this class?' : 'This class will be permanently deleted, Are you sure that you want continue?'}`}
        cancelButton={'No'}
        confirmButton={'Yes'}
        confirmationInProgress={hideInProgress}
      />

      <ConfirmationModal
        isOpen={openUnhideConfirmation}
        onClose={() => setOpenUnhideConfirmation(false)}
        onSave={() => manageUnhide()}
        contentWidth={'40%'}
        buttonPosition={'center'}
        titleName={'Unhide Confirmation'}
        content={'Are you sure that you want to unhide this class?'}
        cancelButton={'No'}
        confirmButton={'Yes'}
        confirmationInProgress={unhideInProgress}
      />
    </div>
  );
};

export default Welcome;
